/** Thumbnail render scale — small enough to fit 3–4 per row in the 920px drawer. */
export const THUMBNAIL_SCALE = 0.3;

/** Full-view scale for the lightbox main panel. */
export const LIGHTBOX_FULL_SCALE = 1.0;

/** Zoom step for lightbox zoom in/out buttons. */
export const LIGHTBOX_ZOOM_STEP = 0.25;

/** Minimum scale in the lightbox. */
export const LIGHTBOX_MIN_SCALE = 0.5;

/** Maximum scale in the lightbox. */
export const LIGHTBOX_MAX_SCALE = 3.0;

/** Rotation step in degrees. */
export const ROTATION_STEP = 90;

/** @enum {string} — loading states for source content fetch */
export const SourceLoadStatus = {
  IDLE: 'idle',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error',
};

/** MIME type prefix for PDF content from the backend. */
export const PDF_CONTENT_TYPE_PREFIX = 'application/pdf';
